import styled from '@emotion/styled';
import { Box, Heading, theme } from '@hover/blueprint';
import React from 'react';
import { animated, useSpring } from 'react-spring';

import { BackgroundLogo } from 'src/modules/designStudio/components/BackgroundLogo';
import { animationConfig } from 'src/modules/designStudio/helpers/animationConfig';
import { useTranslate } from 'src/shared/hooks';
import { TranslationNamespace } from 'src/shared/hooks/useTranslate';

const Container = styled(Box)`
  background-color: ${theme.colors.primary.base};
`;

const ShareErrorPage = () => {
  const props = useSpring(animationConfig.loaderAnimation);

  const t = useTranslate(TranslationNamespace.DESIGN_STUDIO);
  return (
    <Container
      alignItems="center"
      bottom={0}
      flex={1}
      justifyContent="center"
      left={0}
      overflow="hidden"
      paddingX={400}
      position="absolute"
      right={0}
      testId="share-error"
      top={0}
    >
      <BackgroundLogo />
      <animated.div style={props}>
        <Heading color="neutral000" size={500} textAlign="center">
          {t('share.shareError')}
        </Heading>
      </animated.div>
    </Container>
  );
};

export { ShareErrorPage };
